import React, { useState, useEffect } from "react";
import instance from "../../api/api";
import InputCreate from "../../features/InputCreate";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import Button from "../../features/Button";
import { Header } from "../../shared/compoments";

function CreateTypes() {
  const styleBtn = {
    padding: ".5em",
    borderRadius: "5px",
    fontWeight: "bold",
    cursor: "pointer",
    color: "black",
    backgroundColor: "rgb(255 177 47 / 99%)",
    marginTop: "1em",
    border: "none",
  };
  const MySwal = withReactContent(Swal);

  const [data, setData] = useState({
    label: "",
    category_id: "",
  });
  const [allCategorie, setAllCategorie] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const createType = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await instance.post("types", data);

      console.log(response);
      if (response.data.status === false) {
        let msgError = [];
        for (const property in response.data.message) {
          msgError = [...msgError, response.data.message[property]];
        }
        MySwal.fire({
          title: msgError,
          icon: "info",
          showConfirmButton: true,
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setData({
          label: "",
        });
        MySwal.fire({
          title: "Enregistrement reussi.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const listerAll = async () => {
      const responseCategorie = await instance.get("categories");
      setAllCategorie(responseCategorie?.data?.data);
    };
    listerAll();
  }, []);

  return (
    <div>
      {/* <h1>Enregistrer un type de bien</h1> */}
      <Header libelle={"Enregistrer un type de bien"} />
      <form onSubmit={createType} className="create-user">
        <div className="row g-3">
          {/* Champ Type */}
          <div className="col-lg-6">
            <InputCreate
              label="Type"
              typeInput="text"
              nameInput="name"
              active={true}
              getValue={(e) => {
                setData({ ...data, label: e.target.value });
              }}
              dataValue={data.label}
            />
          </div>

          {/* Sélecteur de catégorie */}
          <div className="col-lg-6">
            <label htmlFor="all_categorie" className="form-label">
              Catégories
            </label>
            <select
              name="categories"
              id="all_categorie"
              defaultValue={""}
              onChange={(e) => {
                setData({ ...data, category_id: e.target.value });
              }}
              className="form-select">
              <option value="" disabled>
                Sélectionner une catégorie
              </option>
              {allCategorie.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          {/* Bouton Enregistrer (pleine largeur sur mobile, centré) */}
          <div className="col-lg-4 d-flex align-items-end">
            <Button
              titre="Enregistrer"
              styleBtn={styleBtn}
              isLoading={isLoading}
            />
          </div>
        </div>
      </form>
      {/* <form onSubmit={createType} className="create-user">
        <InputCreate
          label="Type"
          typeInput="text"
          nameInput="name"
          active={true}
          getValue={(e) => {
            setData({ ...data, label: e.target.value });
          }}
          dataValue={data.label}
        />
        <div>
          <label htmlFor="categories">Catégories</label>
          <select
            name="categories"
            id="all_categorie"
            defaultValue={""}
            onChange={(e) => {
              setData({ ...data, category_id: e.target.value });
            }}
            className="w-100 p-3 mb-2">
            <option value={""} disabled>
              Sélectionner une catégorie
            </option>
            {allCategorie.map((item) => (
              <option key={item.id} value={item.id}>
                {item.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <Button
            titre="Enregistrer"
            styleBtn={styleBtn}
            isLoading={isLoading}
          />
        </div>
      </form> */}
    </div>
  );
}

export default CreateTypes;
